module.exports = __webpack_public_path__ + "img/dep-just-sky-m.4f779cac.jpg";